import { render, staticRenderFns } from "./modal-edit-team.vue?vue&type=template&id=244a5090&scoped=true&"
import script from "./modal-edit-team.vue?vue&type=script&lang=js&"
export * from "./modal-edit-team.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&"
import style1 from "./modal-edit-team.vue?vue&type=style&index=1&id=244a5090&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "244a5090",
  null
  
)

export default component.exports